// extracted by mini-css-extract-plugin
export default {"root":"GroupData_root__2gPSn","table":"GroupData_table__BWKnS"};